"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.moveUndone = exports.MOVE_UNDONE = void 0;
exports.MOVE_UNDONE = 'MOVE_UNDONE';
function moveUndone(actionId, delayed) {
    if (delayed === void 0) { delayed = false; }
    return { type: exports.MOVE_UNDONE, actionId: actionId, delayed: delayed };
}
exports.moveUndone = moveUndone;
//# sourceMappingURL=MoveUndone.js.map